import { httpClientUser } from 'Api/microservice-http-clients';

export async function getAccountList() {
  const { data } = await httpClientUser.get('/account');
  return data;
}

export async function getAccount(accountId) {
  const { data } = await httpClientUser.get(`/account/${accountId}`);
  return data;
}

export async function deleteAccount(accountId) {
  return httpClientUser.delete(`/account/${accountId}`);
}

export async function getAccountKYCLinkToken(accountId) {
  const { data } = await httpClientUser.get(`/account/${accountId}/create_link_token`);
  return data?.link_token || '';
}

export async function postAccountKYCVerify(accountId, linkSessionId) {
  return httpClientUser.post(`/account/${accountId}/verify`, { link_session_id: linkSessionId });
}

export async function getAccountSuitability(accountId) {
  const { data } = await httpClientUser.get(`/account/${accountId}/suitability`);
  if (data?.employment_status === '') {
    delete data.is_experienced;
    delete data.is_fin_regulator;
  }
  return data || {};
}

export async function getIsAccountBusinessNameExist(name, accountType) {
  const { data } = await httpClientUser.get(`/account/exists?name=${name}&type=${accountType}`);
  return Boolean(data.exists);
}
